import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Tabs from '../../../components/Tabs';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

import bilingualism from './bilingualism@large.jpg';
import ibpyp from './ibpyp@large.jpg';

const tabs = ['Bilingualism', 'IBPYP'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="en" pageKey="approaches-to-learning">
        <h1>Approaches to Learning</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <p>
              The bilingual nature of Kingston makes it truly unique. Putonghua and English are the languages of
              instruction at Kingston with the expectations that students work and participate in both languages. Every
              class has one native speaking fully qualified Putonghua teacher and one native speaking fully qualified
              English teacher.
            </p>
            <p>
              Each day students spend a portion of the day immersed in English and a portion immersed in Putonghua with
              the rest of the day spent working in both languages.
            </p>
            <p>
              We are very proud of our students' abilities in both languages. We provide the perfect environment for
              native fluency in both English and Putonghua. Our small class numbers and high teacher-to-student ratio
              form the cornerstone of our bilingual approach, which is delivered through the IBPYP framework.
            </p>
            <img src={bilingualism} alt="Bilingualism" />
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <p>
              At Kingston, we believe students learn through meaningful learning engagements that allow children to
              explore through real-life, hands on experiences. Our teachers use an inquiry-based, concept-driven
              approach which increases the students understanding of languages and cultures, and allows the exploration
              of globally significant ideas and issues. At Kingston, we are preparing students to be active participants
              in a lifelong journey of learning.
            </p>
            <img src={ibpyp} alt="IBPYP" />
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
